export default __webpack_public_path__ + "static/media/logo.58c40330.png";